import { Badge } from '@/components/ui/badge';
import { IMAGES } from './retreatsData';

export const RetreatLegacy = () => (
  <section id="our-story" className="py-20 px-6 bg-cream" data-testid="retreat-legacy-section">
    <div className="max-w-6xl mx-auto">
      <div className="grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <Badge className="bg-forest/10 text-forest mb-4">Our Retreat Legacy</Badge>
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-forest mb-6 leading-tight">
            We&apos;ve Been Just Being <span className="text-terracotta">Since 2022.</span>
          </h2>
          <div className="space-y-4 text-gray-700 text-lg leading-relaxed">
            <p>
              What began as an intimate gathering in Aruba has grown into a series of transformational experiences
              where accomplished women step away from performance, responsibility, and expectation long enough to
              hear themselves again.
            </p>
            <p>
              Across islands, intimate Masterminds, sacred conversations, laughter, tears, rest, adventure, and
              breakthrough moments, one thing has remained constant:
            </p>
          </div>
          <div className="mt-8 p-6 bg-white rounded-2xl border-l-4 border-terracotta shadow-sm">
            <p className="font-heading text-2xl text-forest leading-relaxed">
              You do not have to perform here.
            </p>
            <p className="font-heading text-2xl text-terracotta italic mt-1">
              You get to Just Be.
            </p>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-4">
          <img src={IMAGES.may2022} alt="Just Be Retreat Aruba 2022" className="rounded-2xl h-64 w-full object-cover" loading="lazy" />
          <img src={IMAGES.southAfrica2022} alt="Just Be South Africa 2022" className="rounded-2xl h-64 w-full object-cover mt-8" loading="lazy" />
          <img src={IMAGES.may2024} alt="Just Be Retreat Aruba 2024" className="rounded-2xl h-64 w-full object-cover -mt-8" loading="lazy" />
          <img src={IMAGES.costaRica2026} alt="Just Be Soft Power Costa Rica 2026" className="rounded-2xl h-64 w-full object-cover" loading="lazy" />
        </div>
      </div>
    </div>
  </section>
);
